import { Button } from 'antd';
import { CloudDownloadOutlined } from '@ant-design/icons';
import { useRequest } from 'ahooks';
import { number, string } from 'prop-types';
import { downloadFile } from '@/utils/utils';
import { allFileDownload, fileUrlDownload } from '@/services/common';
import './FileDownload.less';

function FileDownload({
  appendixName, url, attachmentId, fileUrl,
}) {
  // 根据ID、URL下载附件
  const { loading, run } = useRequest(() => allFileDownload(attachmentId, url), {
    manual: true,
    onSuccess: ({ data, filename }) => {
      downloadFile(data, filename);
    },
  });

  // 根据文件url下载附件
  const { loading: fileLoading, run: fileRun } = useRequest(fileUrlDownload, {
    manual: true,
    onSuccess: ({ data, filename }) => {
      downloadFile(data, filename);
    },
  });

  const onChange = () => {
    if (url && attachmentId) {
      run();
    } else if (fileUrl) {
      fileRun({ fileUrl, fileName: appendixName });
    }
  };

  return (
    <div className="manage-detail__file-download">
      <span>{appendixName}</span>
      <Button type="primary" icon={<CloudDownloadOutlined />} loading={loading || fileLoading} onClick={onChange} />
    </div>
  );
}
export default FileDownload;
FileDownload.propTypes = {
  attachmentId: number,
  appendixName: string,
  url: string,
  fileUrl: string,
};
FileDownload.defaultProps = {
  attachmentId: -1,
  appendixName: '',
};
